import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/claim-shark-protection/ClaimSharkProtectionClient.tsx");
